// chat powered by Endear. See https://docs.endearhq.com/docs/getting-started
import { getCSQGlobal, quantumMetricEvent } from './analytics.service';
import { toggleAccessibleIcon } from './accessibility.service';
import { getElementOrParentByClassName, waitForTruthyVal, addUrlProtocol } from '../helpers/utils';
// TODO: which QM events should be kept
const QM_CHAT_CLAIMED_CONVERSATION_ID = 270;
const QM_CHAT_ENDED_CONVERSATION_ID = 110;
const QM_CHAT_SHOWN = 111;
const QM_CHAT_HIDDEN = 112;
// const QM_CHAT_ENDED_ASSOCIATE_ID = 113;
// const QM_CHAT_RATING_SUBMITTED = 114;
// const QM_CHAT_CS_HANDOFF = 138;
// const QM_CHAT_PRIVACY_POLICY_CLICK = 263;
// const QM_CUSTOMER_SERVICE_CHAT_OPENED = 309;
// const QM_CUSTOMER_SERVICE_CHAT_CLOSED = 310;
// const QM_CUSTOMER_SERVICE_CONVERSATION_CREATED = 311;
const QM_CHAT_INBOUND_MESSAGE = 324;
const QM_CHAT_OUTBOUND_MESSAGE = 325;
export const SESSION_STORAGE_CS_CHAT_KEY = "csChatInitiated";
export function setupChatApp() {
    if (window.UNTUCKitConfig.thirdPartyToggles.endear && !window.UNTUCKitConfig.isApp) {
        console.log("setting up endear sales chat app");
        document.body.classList.remove('hide-chat');
        waitForTruthyVal(() => typeof window.endear === 'function').then(() => {
            console.log("endear global object found. adding event listeners");
            document.addEventListener("click", function (e) {
                const target = e.target;
                // use open_chat; open_hero_chat is legacy
                if (getElementOrParentByClassName(target, 'open_chat') || getElementOrParentByClassName(target, 'open_hero_chat')) {
                    e.preventDefault();
                    window.endear("open");
                }
            });
            window.endear("onReady", () => {
                if (window.UNTUCKitConfig.chat.showAssociateAvailableIndicator) {
                    const chatIndicatorEl = document.createElement('span');
                    const status = window.endear.initialState.availability === 'available_for_chat' ? 'available' : 'unavailable';
                    chatIndicatorEl.classList.add('chat-indicator', `chat-indicator--${status}`);
                    chatIndicatorEl.ariaLabel = `Associates are currently ${status}`;
                    Array.from(document.querySelectorAll(".open_chat")).forEach(el => {
                        el.append(chatIndicatorEl.cloneNode());
                    });
                }
            });
            window.endear("onOpen", function () {
                console.log("Endear chat opened");
                quantumMetricEvent(QM_CHAT_SHOWN, 0, '');
                toggleAccessibleIcon('hide');
            });
            window.endear("onMessage", (e) => {
                const { conversationId, direction, senderId } = e.detail;
                console.log("A endear message was sent or received", { conversationId, direction, senderId });
                switch (direction) {
                    case 'INBOUND':
                        quantumMetricEvent(QM_CHAT_INBOUND_MESSAGE, 0, conversationId);
                        break;
                    case 'OUTBOUND':
                        quantumMetricEvent(QM_CHAT_OUTBOUND_MESSAGE, 0, conversationId + ' ' + senderId);
                        break;
                    default:
                        console.log(`Conversation ${conversationId} has an unknown direction: ${direction}`);
                }
            });
            window.endear("onConversation", (e) => {
                const { conversationId, browserContextId, status } = e.detail;
                console.log("A conversation was updated", { conversationId, browserContextId, status });
                switch (status) {
                    case 'OPEN':
                        break;
                    case 'CLOSED':
                        quantumMetricEvent(QM_CHAT_ENDED_CONVERSATION_ID, 0, conversationId);
                        break;
                    case 'BLOCKED':
                        console.log(`Conversation ${conversationId} is blocked.`);
                        break;
                    default:
                        console.log(`Conversation ${conversationId} has an unknown status: ${status}`);
                }
            });
            window.endear("onClose", function () {
                console.log("Endear chat closed");
                quantumMetricEvent(QM_CHAT_HIDDEN, 0, '');
                toggleAccessibleIcon('show');
            });
            window.endear("onConversationClaimed", (e) => {
                var _a, _b;
                console.log("Endear chat onConversationClaimed", e.detail);
                quantumMetricEvent(QM_CHAT_CLAIMED_CONVERSATION_ID, 0, (_b = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.conversationId) !== null && _b !== void 0 ? _b : 0);
                window.endear("setCustomAttribute", {
                    type: "TEXT",
                    key: "Last Chat Claimed",
                    value: new Date().toString()
                });
                getCSQGlobal().push(["replay:link:generate", { withTimestamp: false }, (context) => {
                        const { replayLink } = context;
                        if (replayLink) {
                            window.endear("setCustomAttribute", {
                                type: "URL",
                                key: "contentsquare-session-replay",
                                value: {
                                    name: "Contentsquare Session Replay",
                                    url: addUrlProtocol(replayLink)
                                }
                            });
                        }
                    }]);
                waitForTruthyVal(() => { var _a; return typeof ((_a = window.QuantumMetricAPI) === null || _a === void 0 ? void 0 : _a.getReplay) === 'function' && !!window.QuantumMetricAPI.getReplay(); }, 500, 5)
                    .then(() => {
                    window.endear("setCustomAttribute", {
                        type: "URL",
                        key: "quantum-metric-session-replay",
                        value: {
                            name: "Quantum Metric Session Replay",
                            url: window.QuantumMetricAPI.getReplay()
                        }
                    });
                }).catch(err => {
                    console.error("Could not get QM replay.", err);
                });
            });
        }).catch(() => console.error("Endear sales chat toggled on, but instance not available."));
    }
}
